import { CommonModule } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { AssetSelectionComponent } from '@features/shopping/asset/selection/asset-selection.component';
import { UserAsset } from '@models/dashboard.model';
import { calculateItemsToDelete, getCarrier } from '@models/functions.model';
import { ShoppingCartData } from '@models/shopping-cart.model';
import { TranslationPipe } from '@pipes/translation/translation.pipe';
import { ActivityManagerService } from '@services/activity/manager/activity-manager.service';
import { ModalService } from '@services/modal/modal.service';
import { ShoppingService } from '@services/shopping/shopping.service';
import { TranslationService } from '@services/translation/translation.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'ts-activity-11-line-selection',
  templateUrl: './line-selection.component.html',
  imports: [CommonModule, TranslationPipe, AssetSelectionComponent]
})
export class LineSelectionComponent implements OnInit, OnDestroy {
  asset: UserAsset | undefined;
  shopping_cart: ShoppingCartData;
  private subscriptions: Subscription = new Subscription();

  constructor(
    private activity_manager_svc: ActivityManagerService,
    private modal_svc: ModalService,
    private shopping_svc: ShoppingService,
    private translation_svc: TranslationService
  ) {}

  ngOnInit(): void {
    this.subscriptions.add(
      this.shopping_svc.getShoppingItems().subscribe({
        next: (res: ShoppingCartData) => (this.shopping_cart = res),
        error: (err: HttpErrorResponse) => {}
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  selectAsset(asset: UserAsset): void {
    if (
      this.shopping_cart &&
      this.shopping_cart.shopping_cart_items.length &&
      this.shopping_cart.existing_asset &&
      this.shopping_cart.existing_asset.line?.id !== asset.line?.id
    ) {
      this.modal_svc.confirmationDialog(
        {
          title: this.translation_svc.getTranslatedModalLabels()[0],
          message: this.translation_svc.getTranslatedModalLabels()[1],
          confirm_button_text: this.translation_svc.translate('continue'),
          cancel_button_text: this.translation_svc.translate('cancel'),
          onConfirm: () => {
            this.asset = { ...asset, asset_selection_case: 1 };
            this.confirmClearCart(calculateItemsToDelete(this.shopping_cart.shopping_cart_items));
            this.modal_svc.dismissAll();
          }
        },
        {
          size: 'dialog-centered',
          centered: true,
          backdrop: 'static'
        }
      );
    } else {
      this.asset = { ...asset, asset_selection_case: 1 };
      this.continueSelection();
    }
  }

  private confirmClearCart(ids_to_delete: number[]): void {
    this.shopping_svc.clearSpecifiedCartItems(ids_to_delete, false).subscribe({
      next: (res: ShoppingCartData) => {
        this.shopping_cart = res;
        this.continueSelection();
      },
      error: (err: HttpErrorResponse) => {}
    });
  }

  private continueSelection(): void {
    this.shopping_svc.sendShoppingItems(this.shoppingCartParam(), true).subscribe({
      next: (res: ShoppingCartData) => this.activity_manager_svc.navigateToNextStep(),
      error: (err: HttpErrorResponse) => {}
    });
  }

  private shoppingCartParam(): ShoppingCartData {
    if (
      this.shopping_cart.existing_asset?.device &&
      this.shopping_cart.existing_asset?.device?.id &&
      (this.asset?.device?.id !== this.shopping_cart.existing_asset?.device.id ||
        this.asset?.line.id != this.shopping_cart.existing_asset?.line.id)
    )
      this.shopping_cart.device_include_admin_options =
        this.shopping_cart.accessories_include_admin_options = undefined;

    return {
      ...this.shopping_cart,
      country_id:
        this.asset?.line.country_id ?? this.activity_manager_svc.state().parameter('country')?.id,
      carrier: this.asset?.line && getCarrier(this.asset.line),
      orderTypeId: this.activity_manager_svc.currentOrderTypeId(),
      order_for_person: this.shopping_cart.order_for_person,
      lineId: this.asset?.line.id,
      existing_asset: this.asset,
      progress_stepper: this.activity_manager_svc
        .state()
        .currentStep(this.activity_manager_svc.state().activeStepIndex())
    };
  }
}
